import { TCRColumnLayout } from "./TCRColumnLayout";
import { ThemeContext } from "./ThemeContext";

export const BusinessLoansCompany = (props) => (
	<ThemeContext.Provider value={{ linkText: "Get Rates" }}>
		<TCRColumnLayout {...props} />
	</ThemeContext.Provider>
);
